/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ChangePasswordAdminPayload,
  ChatLogsReq,
  EnabledClassesRequest,
  RegenerateAddonKeyRequest,
  UserChangePasswordPayload,
  UserChatLogsGetParams,
  UserClientGrant,
  UserLoginPayload,
  UserPut,
  UserRegisterPayload
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type userLoginResponse200 = {
  data: void
  status: 200
}

export type userLoginResponseSuccess = (userLoginResponse200) & {
  headers: Headers;
};
;

export type userLoginResponse = (userLoginResponseSuccess)

export const getUserLoginUrl = () => {




  return `/api/User/Login`
}

export const useUserLoginHook = (): (userLoginPayload?: UserLoginPayload, options?: RequestInit) => Promise<userLoginResponse> => {

      const customFetcher = useSfetchMutator();
      return (userLoginPayload?: UserLoginPayload, options?: RequestInit) => {

        return customFetcher(getUserLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(userLoginPayload)
  }
);
      }
  }


export type userMySessionResponse200 = {
  data: void
  status: 200
}

export type userMySessionResponseSuccess = (userMySessionResponse200) & {
  headers: Headers;
};
;

export type userMySessionResponse = (userMySessionResponseSuccess)

export const getUserMySessionUrl = () => {




  return `/api/User/mysession`
}

export const useUserMySessionHook = (): ( options?: RequestInit) => Promise<userMySessionResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getUserMySessionUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type userRegisterResponse200 = {
  data: void
  status: 200
}

export type userRegisterResponseSuccess = (userRegisterResponse200) & {
  headers: Headers;
};
;

export type userRegisterResponse = (userRegisterResponseSuccess)

export const getUserRegisterUrl = () => {




  return `/api/User/Register`
}

export const useUserRegisterHook = (): (userRegisterPayload?: UserRegisterPayload, options?: RequestInit) => Promise<userRegisterResponse> => {

      const customFetcher = useSfetchMutator();
      return (userRegisterPayload?: UserRegisterPayload, options?: RequestInit) => {

        return customFetcher(getUserRegisterUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(userRegisterPayload)
  }
);
      }
  }


export type userChangePasswordResponse200 = {
  data: void
  status: 200
}

export type userChangePasswordResponseSuccess = (userChangePasswordResponse200) & {
  headers: Headers;
};
;

export type userChangePasswordResponse = (userChangePasswordResponseSuccess)

export const getUserChangePasswordUrl = () => {




  return `/api/User/ChangePassword`
}

export const useUserChangePasswordHook = (): (userChangePasswordPayload?: UserChangePasswordPayload, options?: RequestInit) => Promise<userChangePasswordResponse> => {

      const customFetcher = useSfetchMutator();
      return (userChangePasswordPayload?: UserChangePasswordPayload, options?: RequestInit) => {

        return customFetcher(getUserChangePasswordUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(userChangePasswordPayload)
  }
);
      }
  }


export type userUpdateResponse200 = {
  data: void
  status: 200
}

export type userUpdateResponseSuccess = (userUpdateResponse200) & {
  headers: Headers;
};
;

export type userUpdateResponse = (userUpdateResponseSuccess)

export const getUserUpdateUrl = () => {




  return `/api/User`
}

export const useUserUpdateHook = (): (userPut?: UserPut, options?: RequestInit) => Promise<userUpdateResponse> => {

      const customFetcher = useSfetchMutator();
      return (userPut?: UserPut, options?: RequestInit) => {

        return customFetcher(getUserUpdateUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(userPut)
  }
);
      }
  }


export type userGetUserResponse200 = {
  data: void
  status: 200
}

export type userGetUserResponseSuccess = (userGetUserResponse200) & {
  headers: Headers;
};
;

export type userGetUserResponse = (userGetUserResponseSuccess)

export const getUserGetUserUrl = () => {




  return `/api/User`
}

export const useUserGetUserHook = (): ( options?: RequestInit) => Promise<userGetUserResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getUserGetUserUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type userLogoutResponse200 = {
  data: void
  status: 200
}

export type userLogoutResponseSuccess = (userLogoutResponse200) & {
  headers: Headers;
};
;

export type userLogoutResponse = (userLogoutResponseSuccess)

export const getUserLogoutUrl = () => {




  return `/api/User/Logout`
}

export const useUserLogoutHook = (): ( options?: RequestInit) => Promise<userLogoutResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getUserLogoutUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type userUsersResponse200 = {
  data: void
  status: 200
}

export type userUsersResponseSuccess = (userUsersResponse200) & {
  headers: Headers;
};
;

export type userUsersResponse = (userUsersResponseSuccess)

export const getUserUsersUrl = () => {




  return `/api/User/Users`
}

export const useUserUsersHook = (): ( options?: RequestInit) => Promise<userUsersResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getUserUsersUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type userSessionsGet1Response200 = {
  data: void
  status: 200
}

export type userSessionsGet1ResponseSuccess = (userSessionsGet1Response200) & {
  headers: Headers;
};
;

export type userSessionsGet1Response = (userSessionsGet1ResponseSuccess)

export const getUserSessionsGet1Url = () => {




  return `/api/User/Sessions/me`
}

export const useUserSessionsGet1Hook = (): ( options?: RequestInit) => Promise<userSessionsGet1Response> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getUserSessionsGet1Url(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type userLogoutUserGlobalResponse200 = {
  data: void
  status: 200
}

export type userLogoutUserGlobalResponseSuccess = (userLogoutUserGlobalResponse200) & {
  headers: Headers;
};
;

export type userLogoutUserGlobalResponse = (userLogoutUserGlobalResponseSuccess)

export const getUserLogoutUserGlobalUrl = (id: string,) => {




  return `/api/User/LogoutUserGlobal/${id}`
}

export const useUserLogoutUserGlobalHook = (): (id: string, options?: RequestInit) => Promise<userLogoutUserGlobalResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getUserLogoutUserGlobalUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type userGetUserIdFromUUIDResponse200 = {
  data: void
  status: 200
}

export type userGetUserIdFromUUIDResponseSuccess = (userGetUserIdFromUUIDResponse200) & {
  headers: Headers;
};
;

export type userGetUserIdFromUUIDResponse = (userGetUserIdFromUUIDResponseSuccess)

export const getUserGetUserIdFromUUIDUrl = (uuid: string,) => {




  return `/api/User/GetUserIdFromUUID/${uuid}`
}

export const useUserGetUserIdFromUUIDHook = (): (uuid: string, options?: RequestInit) => Promise<userGetUserIdFromUUIDResponse> => {

      const customFetcher = useSfetchMutator();
      return (uuid: string, options?: RequestInit) => {

        return customFetcher(getUserGetUserIdFromUUIDUrl(uuid),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type userChatLogsPostResponse200 = {
  data: void
  status: 200
}

export type userChatLogsPostResponseSuccess = (userChatLogsPostResponse200) & {
  headers: Headers;
};
;

export type userChatLogsPostResponse = (userChatLogsPostResponseSuccess)

export const getUserChatLogsPostUrl = () => {




  return `/api/User/ChatLogs`
}

export const useUserChatLogsPostHook = (): (chatLogsReq?: ChatLogsReq, options?: RequestInit) => Promise<userChatLogsPostResponse> => {

      const customFetcher = useSfetchMutator();
      return (chatLogsReq?: ChatLogsReq, options?: RequestInit) => {

        return customFetcher(getUserChatLogsPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(chatLogsReq)
  }
);
      }
  }


export type userChatLogsGetResponse200 = {
  data: void
  status: 200
}

export type userChatLogsGetResponseSuccess = (userChatLogsGetResponse200) & {
  headers: Headers;
};
;

export type userChatLogsGetResponse = (userChatLogsGetResponseSuccess)

export const getUserChatLogsGetUrl = (from: string,
    to: string,
    params?: UserChatLogsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/ChatLogs/${from}/${to}?${stringifiedParams}` : `/api/User/ChatLogs/${from}/${to}`
}

export const useUserChatLogsGetHook = (): (from: string,
    to: string,
    params?: UserChatLogsGetParams, options?: RequestInit) => Promise<userChatLogsGetResponse> => {

      const customFetcher = useSfetchMutator();
      return (from: string,
    to: string,
    params?: UserChatLogsGetParams, options?: RequestInit) => {

        return customFetcher(getUserChatLogsGetUrl(from,to,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type userAuditLogResponse200 = {
  data: void
  status: 200
}

export type userAuditLogResponseSuccess = (userAuditLogResponse200) & {
  headers: Headers;
};
;

export type userAuditLogResponse = (userAuditLogResponseSuccess)

export const getUserAuditLogUrl = () => {




  return `/api/User/AuditLog`
}

export const useUserAuditLogHook = (): ( options?: RequestInit) => Promise<userAuditLogResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getUserAuditLogUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type userGetGrantsForUserResponse200 = {
  data: void
  status: 200
}

export type userGetGrantsForUserResponseSuccess = (userGetGrantsForUserResponse200) & {
  headers: Headers;
};
;

export type userGetGrantsForUserResponse = (userGetGrantsForUserResponseSuccess)

export const getUserGetGrantsForUserUrl = () => {




  return `/api/User/OAuth/Grants`
}

export const useUserGetGrantsForUserHook = (): ( options?: RequestInit) => Promise<userGetGrantsForUserResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getUserGetGrantsForUserUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type userGrantClientResponse200 = {
  data: void
  status: 200
}

export type userGrantClientResponseSuccess = (userGrantClientResponse200) & {
  headers: Headers;
};
;

export type userGrantClientResponse = (userGrantClientResponseSuccess)

export const getUserGrantClientUrl = () => {




  return `/api/User/OAuth/Grant`
}

export const useUserGrantClientHook = (): (userClientGrant?: UserClientGrant, options?: RequestInit) => Promise<userGrantClientResponse> => {

      const customFetcher = useSfetchMutator();
      return (userClientGrant?: UserClientGrant, options?: RequestInit) => {

        return customFetcher(getUserGrantClientUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(userClientGrant)
  }
);
      }
  }


export type userRevokeGrantResponse200 = {
  data: void
  status: 200
}

export type userRevokeGrantResponseSuccess = (userRevokeGrantResponse200) & {
  headers: Headers;
};
;

export type userRevokeGrantResponse = (userRevokeGrantResponseSuccess)

export const getUserRevokeGrantUrl = (grantId: string,) => {




  return `/api/User/OAuth/Grant/${grantId}`
}

export const useUserRevokeGrantHook = (): (grantId: string, options?: RequestInit) => Promise<userRevokeGrantResponse> => {

      const customFetcher = useSfetchMutator();
      return (grantId: string, options?: RequestInit) => {

        return customFetcher(getUserRevokeGrantUrl(grantId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type userGetMyTenantResponse200 = {
  data: void
  status: 200
}

export type userGetMyTenantResponseSuccess = (userGetMyTenantResponse200) & {
  headers: Headers;
};
;

export type userGetMyTenantResponse = (userGetMyTenantResponseSuccess)

export const getUserGetMyTenantUrl = () => {




  return `/api/User/tenant`
}

export const useUserGetMyTenantHook = (): ( options?: RequestInit) => Promise<userGetMyTenantResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getUserGetMyTenantUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type userGetUserByIdResponse200 = {
  data: void
  status: 200
}

export type userGetUserByIdResponseSuccess = (userGetUserByIdResponse200) & {
  headers: Headers;
};
;

export type userGetUserByIdResponse = (userGetUserByIdResponseSuccess)

export const getUserGetUserByIdUrl = (id: string,) => {




  return `/api/User/${id}`
}

export const useUserGetUserByIdHook = (): (id: string, options?: RequestInit) => Promise<userGetUserByIdResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getUserGetUserByIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type userDeleteResponse200 = {
  data: void
  status: 200
}

export type userDeleteResponseSuccess = (userDeleteResponse200) & {
  headers: Headers;
};
;

export type userDeleteResponse = (userDeleteResponseSuccess)

export const getUserDeleteUrl = (id: string,) => {




  return `/api/User/${id}`
}

export const useUserDeleteHook = (): (id: string, options?: RequestInit) => Promise<userDeleteResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getUserDeleteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type userChangePasswordAdminResponse200 = {
  data: void
  status: 200
}

export type userChangePasswordAdminResponseSuccess = (userChangePasswordAdminResponse200) & {
  headers: Headers;
};
;

export type userChangePasswordAdminResponse = (userChangePasswordAdminResponseSuccess)

export const getUserChangePasswordAdminUrl = () => {




  return `/api/User/ChangePasswordAdmin`
}

export const useUserChangePasswordAdminHook = (): (changePasswordAdminPayload?: ChangePasswordAdminPayload, options?: RequestInit) => Promise<userChangePasswordAdminResponse> => {

      const customFetcher = useSfetchMutator();
      return (changePasswordAdminPayload?: ChangePasswordAdminPayload, options?: RequestInit) => {

        return customFetcher(getUserChangePasswordAdminUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(changePasswordAdminPayload)
  }
);
      }
  }


export type userSessionsGet2Response200 = {
  data: void
  status: 200
}

export type userSessionsGet2ResponseSuccess = (userSessionsGet2Response200) & {
  headers: Headers;
};
;

export type userSessionsGet2Response = (userSessionsGet2ResponseSuccess)

export const getUserSessionsGet2Url = (id: string,) => {




  return `/api/User/Sessions/${id}`
}

export const useUserSessionsGet2Hook = (): (id: string, options?: RequestInit) => Promise<userSessionsGet2Response> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getUserSessionsGet2Url(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type userSessionResponse200 = {
  data: void
  status: 200
}

export type userSessionResponseSuccess = (userSessionResponse200) & {
  headers: Headers;
};
;

export type userSessionResponse = (userSessionResponseSuccess)

export const getUserSessionUrl = (id: string,) => {




  return `/api/User/Session/${id}`
}

export const useUserSessionHook = (): (id: string, options?: RequestInit) => Promise<userSessionResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getUserSessionUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type userAuditLogAdminResponse200 = {
  data: void
  status: 200
}

export type userAuditLogAdminResponseSuccess = (userAuditLogAdminResponse200) & {
  headers: Headers;
};
;

export type userAuditLogAdminResponse = (userAuditLogAdminResponseSuccess)

export const getUserAuditLogAdminUrl = (id: string,) => {




  return `/api/User/AuditLog/${id}`
}

export const useUserAuditLogAdminHook = (): (id: string, options?: RequestInit) => Promise<userAuditLogAdminResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getUserAuditLogAdminUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type userEnabledClassesPostResponse200 = {
  data: void
  status: 200
}

export type userEnabledClassesPostResponseSuccess = (userEnabledClassesPostResponse200) & {
  headers: Headers;
};
;

export type userEnabledClassesPostResponse = (userEnabledClassesPostResponseSuccess)

export const getUserEnabledClassesPostUrl = () => {




  return `/api/User/EnabledClasses`
}

export const useUserEnabledClassesPostHook = (): (enabledClassesRequest?: EnabledClassesRequest, options?: RequestInit) => Promise<userEnabledClassesPostResponse> => {

      const customFetcher = useSfetchMutator();
      return (enabledClassesRequest?: EnabledClassesRequest, options?: RequestInit) => {

        return customFetcher(getUserEnabledClassesPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(enabledClassesRequest)
  }
);
      }
  }


export type userEnabledClassesGetResponse200 = {
  data: void
  status: 200
}

export type userEnabledClassesGetResponseSuccess = (userEnabledClassesGetResponse200) & {
  headers: Headers;
};
;

export type userEnabledClassesGetResponse = (userEnabledClassesGetResponseSuccess)

export const getUserEnabledClassesGetUrl = (id: string,) => {




  return `/api/User/EnabledClasses/${id}`
}

export const useUserEnabledClassesGetHook = (): (id: string, options?: RequestInit) => Promise<userEnabledClassesGetResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getUserEnabledClassesGetUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type userRegenerateAddonKeyResponse200 = {
  data: void
  status: 200
}

export type userRegenerateAddonKeyResponseSuccess = (userRegenerateAddonKeyResponse200) & {
  headers: Headers;
};
;

export type userRegenerateAddonKeyResponse = (userRegenerateAddonKeyResponseSuccess)

export const getUserRegenerateAddonKeyUrl = () => {




  return `/api/User/RegenerateAddonKey`
}

export const useUserRegenerateAddonKeyHook = (): (regenerateAddonKeyRequest?: RegenerateAddonKeyRequest, options?: RequestInit) => Promise<userRegenerateAddonKeyResponse> => {

      const customFetcher = useSfetchMutator();
      return (regenerateAddonKeyRequest?: RegenerateAddonKeyRequest, options?: RequestInit) => {

        return customFetcher(getUserRegenerateAddonKeyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(regenerateAddonKeyRequest)
  }
);
      }
  }


export type userSwitchAllClassesResponse200 = {
  data: void
  status: 200
}

export type userSwitchAllClassesResponseSuccess = (userSwitchAllClassesResponse200) & {
  headers: Headers;
};
;

export type userSwitchAllClassesResponse = (userSwitchAllClassesResponseSuccess)

export const getUserSwitchAllClassesUrl = (on: boolean,) => {




  return `/api/User/SwitchAllClasses/${on}`
}

export const useUserSwitchAllClassesHook = (): (on: boolean, options?: RequestInit) => Promise<userSwitchAllClassesResponse> => {

      const customFetcher = useSfetchMutator();
      return (on: boolean, options?: RequestInit) => {

        return customFetcher(getUserSwitchAllClassesUrl(on),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


